/**
 * XXX XXX XXX XXX XXX XXX XXX XXX XXX XXX XXX XXX XXX XXX XXX XXX XXX
 *
 * THIS FILE IS MANAGED CENTRALLY BY THE `common-code` REPO.
 * IT COULD BE AUTO-REPLACED AT ANY TIME.
 * DO NOT MAKE CUSTOM CHANGES TO THIS FILE.
 * @see https://gitlab.com/dea-aero/development/common-code
 *
 * XXX XXX XXX XXX XXX XXX XXX XXX XXX XXX XXX XXX XXX XXX XXX XXX XXX
 */
export function getServer() {
    // NOTE that this is .hostname which CUTS OFF the port, so :3000 will disappear.
    let port = window.location.port;
    port = port === '3000' ? '' : `:${window.location.port}`;
    return `https://${window.location.hostname}${port}${window.location.pathname}`.replace(/\/$/,'')
}

export const ucFirst = s => s.charAt(0).toUpperCase() + s.slice(1);
